import React, {useState} from 'react';
import { Button, Badge } from 'react-bootstrap';
import { useContext } from 'react';
import SimpleContext from './../../context//SimpleContext';

const Counter2 = ({ProCount, min, max, numUnit, unit, fresh, price, slug, name, stock, numSale, goodsRef, uniqueid}) => {

    const context = useContext(SimpleContext);

    const [num, setNum] = useState(ProCount);

        
    const increment = () => {
        
        context.badgeNum(slug)
        setNum(context.PrdCount)

        if (max > num ){
            setNum(num + 1);
            context.handleAddProduct({min, max, name, slug, goodsRef, uniqueid, price, num:{num}, numUnit, numSale, unit,stock, numSale})
        }else{
            setNum(max)
            context.HandelShowContentPage('7')
        }
    };


    const decrement = () => {
        setNum(ProCount - 1);
        if (min < ProCount ){
            setNum(ProCount - 1);
            context.handleRemoveProduct({min, max, name, slug, goodsRef, uniqueid, price, num:{num}, numUnit, numSale, unit, stock, numSale})
        }else{
            setNum(min)
            context.HandelShowContentPage('12')
        }
    };
   
    
    return ( 
        <>            
            <Button
                variant="success"
                className="btn btn-sm fa fa-plus Sabadplusbtn"
                onClick={increment}
            />

            <Badge className="Sabadbadgbtn">
                <p>
                    {ProCount} {unit}  
                    {numSale}  عددی 
                </p>
            </Badge>
                
            <Button
                variant="success"
                className="btn btn-sm fa fa-minus Sabadminusbtn"
                onClick={decrement}
            />
            
        </>
     );
}
 
export default Counter2;